export default "__VITE_ASSET__2f15711f__"